import React, { useEffect } from 'react'
import Banner from './Banner/Banner'
import Navbar from '../../landing/header/Navbar'
import { Link } from 'react-router-dom'

const IncentivDetailPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <>
            <div className="wrapper-detailpage">
                <Navbar />
                <Banner />
            </div>
        </>
    )
}

export default IncentivDetailPage
